import { getAttribute } from "@api/attributes";
import CourseCompletionGroup from "@api/types/course-completion-group";
import { CFC } from "@api/types/cypress";
import React from "react";

import CourseCertificateDownload from "@components/CourseCertificateDownload";
import DisabledButton from "@components/DisabledButton";
import EnrolledCourseDetails from "@components/EnrolledCourseDetails";
import EnrolledCourseImage from "@components/EnrolledCourseImage";
import AdditionalInformationForm from "@components/EnrolledCourseRegistrationForm/AdditionalInformationForm";
import LaunchCourseButton from "@components/LaunchCourseButton";
import Spacer from "@components/Spacer";

const EnrolledCourseGroup: CFC<{ enrollmentGroup: CourseCompletionGroup }> = ({ enrollmentGroup }) => {
  const { completions } = enrollmentGroup;

  const sortedCompletions = [...completions].sort(function (p1, p2) {
    return p1.coursePackagePosition - p2.coursePackagePosition;
  });

  const completion = sortedCompletions[0];

  const showAdditionalInformationForm = () => {
    // all the completions have these attributes
    const registrationFormCompleted =
      sortedCompletions.filter(
        (c) => getAttribute(c.registrationInfo.data, "registrationFormCompleted") === "true"
      ).length === completions.length;

    // registration required and have not been completed
    return completion.courseObject.courseRegRequired && !registrationFormCompleted;
  };

  return (
    <>
      <div className="EnrolledCourse">
        <div className="thumbnail">
          <EnrolledCourseImage completion={completion} />
        </div>
        <div className="details">
          <EnrolledCourseDetails completion={completion} />
        </div>
        <div className="actions">
          <div className="row">
            {completion.enabled && showAdditionalInformationForm() ? (
              <AdditionalInformationForm completion={completion} />
            ) : (
              <>
                {completion.enabled ? (
                  sortedCompletions.map((c) => (
                    <>
                      {c.coursePackagePrerequisitesMet ? (
                        <LaunchCourseButton
                          completion={c}
                          buttonText={
                            c.coursePackageName && c.coursePackageName.length > 0
                              ? c.coursePackageName
                              : "Launch"
                          }
                        />
                      ) : (
                        <DisabledButton
                          buttonText={
                            c.coursePackageName && c.coursePackageName.length > 0
                              ? c.coursePackageName
                              : "Not Available"
                          }
                        />
                      )}
                      <Spacer size={"sm"} />
                    </>
                  ))
                ) : (
                  <DisabledButton buttonText="Inactive" />
                )}
              </>
            )}
          </div>
          {completion.enabled && (
            <div className="row">
              <CourseCertificateDownload completion={completion} />
            </div>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .EnrolledCourse {
            display: grid;
            grid-template-columns: repeat(12, 1fr);
          }

          .thumbnail {
            grid-column: 1/13;
            margin-bottom: 20px;
          }

          .details {
            grid-column: 1/13;
            margin-bottom: 20px;
          }

          .actions {
            grid-column: 1/13;
            margin-bottom: 20px;
          }

          @media screen and (min-width: 768px) {
            .EnrolledCourse {
              grid-column-gap: 40px;
            }

            .thumbnail {
              grid-column: 1/4;
              margin-bottom: 0;
            }

            .details {
              grid-column: 4/10;
              margin-bottom: 0;
            }

            .actions {
              grid-column: 10/13;
              margin-bottom: 0;
            }
          }
        `}
      </style>
    </>
  );
};

export default EnrolledCourseGroup;
